import InputNumberOfPeopleSelector from 'components/InputNumberOfPeople/InputNumberOfPeopleSelector';
import Popover from 'components/Popover';
import { getFilter } from 'data/filters';
import useStores from 'hooks/useStores';
import PopoverFooter from 'modules/common/Popovers/PopoverFooter';
import { PopoverTriggerSource } from 'modules/common/SubBars/ExperienceFilterSubNavbar/usePopoverTrigger';
import routeToSearchURL from 'modules/homescreen/helpers/routeToSearchURL';
import React, { useState } from 'react';
import { useTrekker } from 'utils/analytics';
import useLocalizedNavigate from '~/hooks/useLocalizedNavigate';

const CSS = require('./PeoplePopover.module.scss');

interface PeoplePopoverProps {
  nrOfAdults: number;
  nrOfChildren: number;
  onClose: (args: {
    source: PopoverTriggerSource;
    callback?: () => void;
  }) => void;
}

const stores = [];
function getStateFromStore(flux) {
  const setFilterGuests = (guests) => {
    flux.actions.filters.setGuests(guests);
  };

  return {
    setFilterGuests,
  };
}

function PeoplePopover({
  nrOfAdults,
  nrOfChildren,
  onClose,
}: PeoplePopoverProps) {
  const trekker = useTrekker();
  const navigate = useLocalizedNavigate();

  const [guests, setGuests] = useState({
    nrOfAdults,
    nrOfChildren,
  });

  const { setFilterGuests } = useStores(stores, getStateFromStore);

  const onApply =
    (source: 'escape button' | 'outside click' | 'apply button') => (e) => {
      e?.stopPropagation();

      const adultsFilter = getFilter('adults');
      const childrenFilter = getFilter('children');
      adultsFilter.value = guests.nrOfAdults;
      childrenFilter.value = guests.nrOfChildren;

      setFilterGuests(guests);

      trekker.event('click', {
        action: 'people filter',
        buttonText: 'apply',
        nrOfAdults,
        nrOfChildren,
      });

      onClose({
        source,
        callback: () => {
          const { to, replace } = routeToSearchURL({
            filtersToAdd: [adultsFilter, childrenFilter],
            replace: true,
          });
          navigate(to, { replace });
        },
      });
    };

  const onClear = () => {
    trekker.event('click', {
      action: 'people filter',
      buttonText: 'clear',
    });
    onClose({ source: 'clear button' });
  };

  const onGuestsChange = (nrOfAdults, nrOfChildren) => {
    setGuests({
      nrOfAdults,
      nrOfChildren,
    });
  };

  return (
    <Popover
      show
      name="peoplePopover"
      underNavbar
      className={CSS.Popover}
      onClose={onApply('escape button')}
      onOutSideClick={onApply('outside click')}
    >
      <InputNumberOfPeopleSelector
        onChange={onGuestsChange}
        nrOfAdultsInitialValue={nrOfAdults}
        nrOfChildrenInitialValue={nrOfChildren}
        maxPeople={20}
      />
      <PopoverFooter onClear={onClear} onApply={onApply('apply button')} />
    </Popover>
  );
}

export default PeoplePopover;
